export default "__VITE_ASSET__C$7nqe5B__"